import { AxiosResponse } from 'axios';

import api from 'utils/apiClient';
import { IEditInfoScreen, IInfoScreenData } from '../types/infoScreens.types';

export const loadInfoScreen = ({ id }: { id: number }): Promise<AxiosResponse<IInfoScreenData>> => {
  return api.get(`/info_screens/${id}`);
};

export const updateInfoScreen = ({
  id,
  data
}: { id: number, data: IEditInfoScreen }): Promise<AxiosResponse<IInfoScreenData>> => {
  return api.patch(`/info_screens/${id}`, data, {
    headers: {
      'Content-Type': 'application/ld+json',
    }
  });
};
